import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "72",
  height: "80",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M36.412 56.807c9.162 0 16.589-7.6 16.589-16.974S45.574 22.86 36.412 22.86s-16.588 7.6-16.588 16.974 7.427 16.974 16.588 16.974"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#151515",
      d: "M25.363 47.222V32.41h2.931v14.812zM29.757 47.222V32.41h3.663q.947 0 1.751.165a3.9 3.9 0 0 1 1.421.585 2.7 2.7 0 0 1 .947 1.161q.33.74.33 1.93 0 .896-.25 1.526-.249.63-.714.997-.465.365-1.144.493.84.129 1.412.586t.858 1.206.286 1.81q0 1.116-.277 1.94-.278.822-.813 1.352a3.4 3.4 0 0 1-1.323.796q-.786.265-1.823.265zm2.948-8.832h.733q.769 0 1.162-.229a1.2 1.2 0 0 0 .545-.695q.152-.466.152-1.143 0-.675-.224-1.088a1.3 1.3 0 0 0-.679-.594q-.456-.183-1.152-.183h-.536zm0 6.71h.822q1.108 0 1.528-.566.42-.567.42-1.7 0-.878-.196-1.4a1.42 1.42 0 0 0-.635-.767q-.438-.247-1.17-.247h-.769zM42.963 47.44q-1.466 0-2.324-.63t-1.224-1.792-.366-2.697v-4.956q0-1.59.375-2.743t1.313-1.774 2.547-.621q1.556 0 2.457.53a3 3 0 0 1 1.296 1.5q.393.97.393 2.303v.86h-2.877v-1.042q0-.585-.072-1.034-.071-.448-.33-.703-.26-.257-.831-.257-.59 0-.858.311a1.53 1.53 0 0 0-.34.796 7 7 0 0 0-.07 1.033v6.565q0 .621.106 1.115.108.494.402.768t.85.274q.554 0 .857-.292.304-.292.42-.796.116-.503.116-1.142v-1.573h-1.412v-1.829h4.075v7.607h-1.93l-.179-1.334q-.286.675-.858 1.115-.57.438-1.536.438"
    }, null, -1)
  ]))]))
}
export default { render: render }